import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ExtendedSubscriptionInterval, LicenseType } from '@platform-frontend/marketplace';
import { ShowWarningNotification } from '@platform-frontend/util';
import { Observable, of } from 'rxjs';
import { MSG_SELECT_LICENSE_TYPE_VALIDITY_PERIOD_INFO } from '../notification-messages';

@Injectable({ providedIn: 'root' })
export class LicenseValidityWarningService {
  constructor(private readonly store: Store) {}

  checkValidity(licenseType: LicenseType | null): Observable<unknown> {
    if (!licenseType || licenseType.kind.type !== 'SUBSCRIPTION') {
      return of(null);
    }

    const subscriptionInterval: ExtendedSubscriptionInterval = licenseType.kind.subscriptionInterval;
    const validityDate: Date | undefined | null = licenseType?.validityUpdate?.context?.date;
    const startOfValidityDate: Date = validityDate ?? new Date(new Date().getFullYear(), new Date().getMonth(), 1);

    let endOfValidityDate: Date;

    switch (subscriptionInterval) {
      case 'DAILY':
        endOfValidityDate = new Date(startOfValidityDate.getFullYear(), startOfValidityDate.getMonth(), startOfValidityDate.getDate() + 1);
        break;
      case 'QUARTERLY':
        endOfValidityDate = new Date(startOfValidityDate.getFullYear(), startOfValidityDate.getMonth() + 3, startOfValidityDate.getDate());
        break;
      case 'YEARLY':
        endOfValidityDate = new Date(startOfValidityDate.getFullYear() + 1, startOfValidityDate.getMonth(), startOfValidityDate.getDate());
        break;
      case 'MONTHLY':
      default:
        endOfValidityDate = new Date(startOfValidityDate.getFullYear(), startOfValidityDate.getMonth() + 1, startOfValidityDate.getDate());
    }

    const now: Date = new Date();
    const totalIntervalMs: number = endOfValidityDate.getTime() - startOfValidityDate.getTime();
    const passedMs: number = now.getTime() - startOfValidityDate.getTime();
    const percentPassed: number = (passedMs / totalIntervalMs) * 100;

    if (percentPassed >= 75 && percentPassed <= 100) {
      const remainingDays = Math.ceil((endOfValidityDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
      return this.store.dispatch(new ShowWarningNotification(MSG_SELECT_LICENSE_TYPE_VALIDITY_PERIOD_INFO(remainingDays)));
    }

    return of(null);
  }
}
